import { useQuery } from 'react-query'

import { CustomerAPI, ReviewAPI } from 'api'
import { isEmptyOrNil } from 'utils/index'

export const THUMBS_UP = 'UP'
export const THUMBS_DOWN = 'DOWN'

export type Thumbs = typeof THUMBS_UP | typeof THUMBS_DOWN

export interface TMessageReview {
  thumbs: Thumbs
  createdAt: number
  createdBy: number
}
export const useConvoReviewerData = (reviewCreatedBy?: number) => {
  return useQuery({
    queryKey: ['convoReviewer', reviewCreatedBy],
    queryFn: () =>
      CustomerAPI.get(`/users/${reviewCreatedBy}`).then(({ data }) => {
        return { data }
      }),
    enabled: !isEmptyOrNil(reviewCreatedBy),
  })
}

export const deleteAIScenarioReview = async (
  conversationId: string,
  messageId: string
) => {
  try {
    await ReviewAPI.delete(
      `/conversations/${conversationId}/reviews/${messageId}`
    )
  } catch (error) {
    console.error('Error deleting review:', error)
    throw error
  }
}

export const getAIScenarioReview = async (
  conversationId: string,
  messageId: string
): Promise<TMessageReview | undefined> => {
  try {
    const response = await ReviewAPI.get(
      `/conversations/${conversationId}/reviews/${messageId}`
    )
    return response.data as TMessageReview
  } catch (error) {
    console.error('Error fetching review status:', error)
    return undefined
  }
}

export const postAIScenarioReview = async (
  conversationId: string,
  messageId: string,
  thumbs: Thumbs,
  scenarioId: string,
  scenarioName: string,
  messageResponseType: string
) => {
  try {
    await ReviewAPI.post(
      `/conversations/${conversationId}/reviews/${messageId}`,
      {
        thumbs,
        messageResponseType,
        scenarioName,
        scenarioId,
      }
    )
  } catch (error) {
    console.error('Error posting review:', error)
    throw error
  }
}
